export {
  matchesSearch,
  parsePrSearch,
  prSearchRank,
  rankPrResults,
} from "../../supabase/functions/_shared/releaseSearch.ts";
const migrationStates: Record<string, string> = {
  applied: "הוחל בייצור",
  not_applied: "טרם הוחל",
  collision: "התנגשות גרסה",
  unknown: "לא אומת",
};
export function queueStatusText(status: string) {
  const words: Record<string, string> = {
    pending: "ממתין",
    approved: "מאושר",
    applying: "בהחלה",
    applied: "הוחל",
    failed: "נכשל",
    cancelled: "בוטל",
  };
  return words[status] ?? "לא אומת";
}
export function migrationSearchText(
  migrations: {
    path: string;
    version: string;
    name: string;
    explanation: string;
    risk: string;
    status: string;
  }[] = [],
) {
  return migrations.map((m) =>
    `DB SQL מיגרציה בסיס נתונים ${m.path} ${m.version} ${m.name} ${m.explanation} ${m.risk} ${m.status} ${
      migrationStates[m.status] ?? ""
    }`
  ).join(" ");
}
export function queueSearchText(
  item: {
    id: string;
    version: string;
    name: string;
    repo: string;
    status: string;
    held: boolean;
    emergency: boolean;
    pr_url: string | null;
    last_error: string | null;
    file_path?: string;
    sql_sha256?: string;
  },
) {
  const statuses: Record<string, string> = {
    pending: "ממתין",
    approved: "מאושר",
    failed: "נכשל",
    applying: "בהחלה",
    applied: "הוחל",
    cancelled: "בוטל",
  };
  return `${item.id} ${item.version} ${item.name} ${item.repo} ${item.status} ${
    statuses[item.status] ?? ""
  } ${item.held ? "מושהה" : ""} ${item.emergency ? "חירום" : ""} ${
    item.pr_url ?? ""
  } ${item.last_error ?? ""} ${
    item.file_path ?? `supabase/migrations/${item.version}_${item.name}.sql`
  } ${item.sql_sha256 ?? ""}`;
}
